import { render, staticRenderFns } from "./Infografico_1.vue?vue&type=template&id=3dd58cb5"
import script from "./Infografico_1.vue?vue&type=script&lang=js"
export * from "./Infografico_1.vue?vue&type=script&lang=js"
import style0 from "./Infografico_1.vue?vue&type=style&index=0&id=3dd58cb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports